import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {debitAndRefund} from '../WelcomeBlock/welcomeBlockSlice';
import FuturePayment from './FuturePayment';
import Config from '../../../Config';
import EpiContext from '@episerver/spa-core/Spa';
import './futurePayments.scss';
import ErrorBlock from '../../Shared/ErrorPage/ErrorBlock';
import {createReportFuturePayments} from '../../../utilities/reports/createReport';

const FuturePaymentsBlockMain = (props) => {
  const payments = props.paymentsState;
  useEffect(() => {
    props.debitAndRefund();
  }, []);

  useEffect(() => {
    if (payments?.isLoading) {
      props.showAppLoader();
    } else {
      props.hideAppLoader();
    }
  }, [payments]);

 

  //variables for report DWH
  const customerName = props.loginData?.userDetails?.firstName+' '+props.loginData?.userDetails?.lastName;
  const contactNumber = props.loginData?.userDetails?.contactNumber;
  const idNumber = props.loginData?.userDetails?.IDNumber;
  const orgId = props.organizationData?.organizationCodeList?.value;


  if (payments?.products?.length && !payments?.isLoading) {
    createReportFuturePayments('Device Payments Displayed',customerName,contactNumber,idNumber,orgId);
    return (
      <div className='future-payments-container'>
        <h1 className='main-title'>{props.iContent.productsPaymentTitle.value}</h1>
        <div className='payments-container'>
          {payments?.products.map((payment) => (
            <FuturePayment payment={payment} />
          )  
          )}
        </div>
       
        <span className='future-payments-button' onClick={() => EpiContext.navigateTo(Config.lobbyUrl)}>
          חזרה לאיזור האישי
        </span>
      </div>
    );
  } else if (!payments?.isLoading) {
    createReportFuturePayments('No Payments Message Displayed',customerName,contactNumber,idNumber,orgId);

    return (
      <ErrorBlock mainTitle='לא מצאנו מידע על תשלומים עבור מכשיר או ציוד' buttonTitle={'חזרה לאיזור האישי'} buttonLink={Config.lobbyUrl} />
      
    );
  } else {
    return <></>;
  }
};

const mapStateToProps = (state) => {
  return {
    paymentsState: state.welcomeBlock.paymentsState,
    loginData: state.authentication?.loginData,
    organizationData: state.welcomeBlock?.organizationState,

  };
};

const mapDispatchToProps = {
  debitAndRefund,
  showAppLoader,
  hideAppLoader,
};
export default connect(mapStateToProps, mapDispatchToProps)(FuturePaymentsBlockMain);
